import { BlankEditorResult } from '@doltech/ui/lib/figma/BlankEditor/Result/BlankEditorResult';
import { QuestionCircle, QuestionCircleType } from '@doltech/ui/lib/figma/CircleText/CircleText';
import { SubText } from '@doltech/ui/lib/figma/Typography';
import { TestModeEnum } from '@doltech/utils/lib/constants';
import { numberToABC } from '@doltech/utils/lib/text';
import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { ReadingTestSectionInstance } from '../../../question-data-model/TestSection/_implementations/reading-test-section.store';
import { DoTestCompletionWithHintQuestionInstance } from '../../../student-do-test/model/Question/do-test-completion-with-hint-question.store';
import { Heading, Main, ParagraphWrapper } from './ViewTestCompetionNoHint';

export interface ViewTestCompletionWithHintProps extends React.HTMLAttributes<HTMLDivElement> {
  data: DoTestCompletionWithHintQuestionInstance;
  currentSection?: ReadingTestSectionInstance;
  isPdfContent: boolean;
}

export const ViewTestCompletionWithHint = (props: ViewTestCompletionWithHintProps) => {
  const { data, isPdfContent, ...rest } = props;
  const { no, heading, paragraph, options } = data;
  const editorValueJs = JSON.parse(paragraph.editorValue);

  return (
    <Main className="dol-question" {...rest}>
      <Heading>{heading}</Heading>
      <ParagraphWrapper>
        <BlankEditorResult
          value={editorValueJs}
          currentSelectedIndex={no}
          testMode={TestModeEnum.VIEW_TEST_QUESTION}
          blanks={paragraph.blanks.map((blank) => {
            return {
              ...blank,
              no: blank.no + no + blank.key,
            };
          })}
        />
      </ParagraphWrapper>
      <Options>
        {options.map((option, idx) => {
          return (
            <Option key={option.key}>
              <QuestionCircle className={cl(QuestionCircleType.GRAY_20, 'option-circle')}>
                <SubText>{numberToABC(idx + 1)}</SubText>
              </QuestionCircle>
              {option.value}
            </Option>
          );
        })}
      </Options>
    </Main>
  );
};

const Options = styled.div`
  margin-top: 20px;
`;

const Option = styled.div`
  display: flex;
  height: 40px;
  line-height: 24px;
  padding: 8px 0;

  &:last-child {
    height: 32px;
    padding-bottom: 0;
  }

  > .option-circle {
    min-width: 24px;
    margin-right: 8px;
  }
`;
